import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import html2pdf from 'html2pdf.js';

const ExcelSheetsToPdf = () => {
  const [sheetsHtml, setSheetsHtml] = useState(null);

  const handleExcelUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (evt) => {
      const data = new Uint8Array(evt.target.result);
      const workbook = XLSX.read(data, { type: 'array' });

      let html = '';

      workbook.SheetNames.forEach((sheetName) => {
        const sheet = workbook.Sheets[sheetName];
        const sheetData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

        html += `<h3>Sheet: ${sheetName}</h3>`;
        html += '<table border="1" cellpadding="5" cellspacing="0">';
        sheetData.forEach((row) => {
          html += '<tr>';
          row.forEach((cell) => {
            html += `<td>${cell ?? ''}</td>`;
          });
          html += '</tr>';
        });
        html += '</table><br/><br/>';
      });

      setSheetsHtml(html);
    };

    reader.readAsArrayBuffer(file);
  };

  const handleDownloadPdf = () => {
    if (!sheetsHtml) return;

    const container = document.createElement('div');
    container.innerHTML = sheetsHtml;
    container.style.padding = '20px';
    container.style.background = '#fff';

    html2pdf()
      .set({
        filename: 'merged-sheets.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
      })
      .from(container)
      .save();
  };

  return (
    <div>
    <div>
      <h2>Merge Excel Sheets to PDF</h2>
      <input type="file" accept=".xlsx, .xls" onChange={handleExcelUpload} />
      <br /><br />
      <button onClick={handleDownloadPdf} disabled={!sheetsHtml}>
        Convert All Sheets to PDF
      </button>
    </div>
    <div className="content">

  <h2>Merge Excel Sheets to PDF: Combine Multiple Sheets into One Document</h2>

  <p>
    When working with complex projects, financial reports, or data analysis, you may 
    have multiple Excel sheets that need to be shared or archived together. The 
    Merge Excel Sheets to PDF tool allows you to combine multiple sheets into a single, 
    professional PDF document.
  </p>

  <p>
    This ensures your data is organized, easy to read, and consistently formatted 
    across all sheets.
  </p>

  <h3>Why Merge Excel Sheets to PDF?</h3>

  <ul>
    <li>Combine multiple sheets into one unified document</li>
    <li>Preserve formatting, charts, and formulas</li>
    <li>Share data securely without allowing edits</li>
    <li>Create professional reports, dashboards, or summaries</li>
    <li>Save time by avoiding separate files for each sheet</li>
  </ul>

  <h3>How the Merge Excel Sheets to PDF Process Works</h3>

  <h4>1. Upload Your Excel File</h4>
  <p>
    Select the Excel file (.xls or .xlsx) containing multiple sheets. The tool reads 
    all sheets and displays a preview of each one.
  </p>

  <h4>2. Choose Sheets to Merge</h4>
  <p>
    Select the specific sheets you want to include in the final PDF, or merge all 
    sheets at once.
  </p>

  <h4>3. Configure Layout Options</h4>
  <p>
    Customize the PDF output with options such as:
  </p>
  <ul>
    <li>Page orientation (Portrait or Landscape)</li>
    <li>Page size (A4, Letter, or Original sheet size)</li>
    <li>Include headers, footers, and page numbers</li>
    <li>Scale content to fit pages properly</li>
  </ul>

  <h4>4. Generate the PDF</h4>
  <p>
    Click “Convert” to merge the selected sheets into a single PDF. The system preserves 
    all formatting, charts, and data, resulting in a clean, professional document.
  </p>

  <h3>Your Final PDF</h3>
  <p>
    After processing, you will have one unified PDF containing all your selected sheets. 
    The file is ready for sharing, printing, or archiving, providing a polished and 
    organized presentation of your Excel data.
  </p>

</div>

    </div>
  );
};

export default ExcelSheetsToPdf;
// src/components/ExcelsheetsToPDF.js